export default {
  description: 'Vytvárajte a spravujte svoje predvoľby',
  presetLabel: 'Vybraná predvoľba',
  nameLabel: 'Názov predvoľby',
  saveAsDefault: 'Uložiť nastavenia ako predvolené',
  publishGlobaly: 'Publikovať pre všetkých používateľov',
  publishGlobalyTooltip: 'Ak chcete zmeniť toto nastavenie, skopírujte alebo vytvorte novú predvoľbu',
  defaultName: 'Nová predvoľba',
  selectPreset: 'Vybrať predvoľbu',
  reset: 'Resetovať',
  apply: 'Použiť bez uloženia',
};
